"use strict";

/* global dataSource, viewOptions */

/* Default listing settings. */

const ItemListingState = {
	done: false,
	dataSourceWorkset: typeof dataSource !== "undefined" ? JSON.parse(JSON.stringify(dataSource)) : false,
	viewOptionsWorkset: typeof viewOptions !== "undefined" ? JSON.parse(JSON.stringify(viewOptions)) : false,
	skipFetch: false,
	currentIndex: 0,
	itemsPerPage: 20,
	lazyLoadingTimes: 3,
	lazyLoadCounter: 3 + 1,
	filtersMoved: false,
	selectedGroups: [],
	nextPage: 2
};

const ItemListingConfig = {
	sessionStorageKey: location.pathname,
	sessionStorageUrlHash: "#s",
	filterDataSelector: "data-listing-filters",
	listingSelector: ".item-listing",
	mobileFilterBarSelector: "#mobile-filter-menu",
	mobileFilterBar: false,
	filterBarSelector: ".filter-bar",
	filterBar: false,
	filterBarItems: ".filter-bar .filter-bar-main-settings *[data-filter]",
	filterBarTextSelector: ".filter-bar .bar-text",
	filterBarText: [],
	itemListingActionsSelector: ".listing-actions",
	itemListingActions: document.createElement("div"),
	mobileMenuActivityAreaselector: "#mobile-filter-menu .activity-area",
	mobileMenuActivityArea: document.createElement("div"),
	listingItemCountSelector: ".item-count",
	listingItemCountWithTextSelector: ".item-count-text",
	listingRemainingItemsCountSelector: ".remaining-item-count",
	listingItemType: "kohde",
	listingItemTypePlural: "kohdetta",
	additionalFilters: [],
	defaultFilterState: {},
	desktopDropdownViewMaxHeight: 600,
	filterColumn: document.createElement("div"),
	filterColumnSelector: ".listing-nav-col",
	loadMoreLink: ".listing-load-more",
	noListingItems: '<p class="no-listing-items">Kohteita ei voitu ladata.</p>',
	ajaxMode: "GET",
	endpoint: "/stage-ajax/"
};

class ItemListingConfigModifier {

	modify(config, mode) {
		if (mode === "state" && config) {
			for (const key of Object.keys(config)) {
				ItemListingState[key] = config[key];
			}
			return ItemListingState;
		}

		if (mode === "config" && config) {
			for (const key of Object.keys(config)) {
				ItemListingConfig[key] = config[key];
			}

			return ItemListingConfig;
		}

	}

	loadConfig() {
		ItemListingState.nextPage = ItemListingState.viewOptionsWorkset.nextPage;
		ItemListingConfig.mobileMenuActivityArea = document.querySelector(ItemListingConfig.mobileMenuActivityAreaSelector) || document.createElement("div");
		ItemListingConfig.filterBar = document.querySelector(ItemListingConfig.filterBarSelector) || false;
		if (ItemListingConfig.filterBar && ItemListingConfig.filterBar.dataset.endpoint) {
			ItemListingConfig.endpoint = String(ItemListingConfig.filterBar.dataset.endpoint).trim();
		}
		ItemListingConfig.mobileFilterBar = document.querySelector(ItemListingConfig.mobileFilterBarSelector) || false;
		ItemListingConfig.filterBarText = document.querySelectorAll(ItemListingConfig.filterBarTextSelector);
		ItemListingConfig.itemListingActions = document.querySelector(ItemListingConfig.itemListingActionsSelector) || document.createElement("div");
		ItemListingConfig.filterCutoffWidth = document.querySelector(ItemListingConfig.filterColumnSelector) ? 700 : 900;
	}
}


const itemListingConfigModifier = new ItemListingConfigModifier();
itemListingConfigModifier.loadConfig();


export { ItemListingState, ItemListingConfig, itemListingConfigModifier };